module.exports = __webpack_public_path__ + "static/media/takeAPeek.96378066.png";